import tippy, { hideAll } from "tippy.js";

const selectors: Record<"dropdown" | "close" | "trigger" | "content" | "button", string> = {
  dropdown: "[data-dropdown]",
  close: "[data-dropdown-close]",
  trigger: "[data-dropdown-trigger]",
  content: "[data-dropdown-content]",
  button: "[data-button]",
};

const classes: Record<"active", string> = {
  active: "active",
};

const mql = window.matchMedia("(min-width: 1024px)");

export const init = () => {
  // @ts-ignore
  window.tippyInstances = [];

  const dropdowns = Array.from(document.querySelectorAll(selectors.dropdown));
  let isDesktop = mql.matches;

  dropdowns.forEach((dropdown) => {
    if (!dropdown) return;

    const close = dropdown.querySelector(selectors.close);
    const content = dropdown.querySelector(selectors.content) as HTMLElement;
    const trigger = dropdown.querySelector(selectors.trigger) as HTMLElement;
    const placement = dropdown.getAttribute("data-dropdown-placement") as string;

    if (close && trigger) {
      close.addEventListener("click", () => {
        dropdown.classList.remove(classes.active);
        trigger.classList.remove(classes.active);
        // @ts-ignore
        trigger.firstElementChild.classList.remove(classes.active);
      });
    }

    trigger.addEventListener("click", () => {
      // @ts-ignore
      trigger.firstElementChild.classList.add(classes.active);
      if (isDesktop) return;

      dropdown.classList.add(classes.active);
      trigger.classList.add(classes.active);
    });

    //@ts-ignore
    const instance = tippy(trigger, {
      content: content.innerHTML,
      allowHTML: true,
      trigger: "click",
      placement,
      interactive: true,
      delay: 0,
      offset: [0, 4],
      animation: false,
      onHide(instance) {
        trigger.classList.remove(classes.active);
        // @ts-ignore
        trigger.firstElementChild.classList.remove(classes.active);
      },
      onShow(instance) {
        hideAll({ exclude: instance });

        trigger.classList.add(classes.active);
        // @ts-ignore
        trigger.firstElementChild.classList.add(classes.active);
      },
    });

    // @ts-ignore
    window.tippyInstances = [...window.tippyInstances, instance];

    if (!isDesktop) {
      instance.disable();
    }

    mql.addEventListener("change", ({ matches }: { matches: boolean }) => {
      isDesktop = matches;
      if (matches) {
        instance.enable();
        return;
      }

      instance.disable();
    });
  });
};

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    init();
  },
  {
    once: true,
  }
);
